const timezones = [
    {
        label: "(UTC -12:00) Baker Island, Howland Island",
        value: "Etc/GMT+12",
        offset: -12
    },
    {
        label: "(UTC -11:00) American Samoa, Midway Island",
        value: "Pacific/Pago_Pago",
        offset: -11
    },
    {
        label: "(UTC -10:00) Hawaii",
        value: "Pacific/Honolulu",
        offset: -10
    },
    {
        label: "(UTC -09:00) Alaska",
        value: "America/Anchorage",
        offset: -9
    },
    {
        label: "(UTC -08:00) Pacific Time (US & Canada)",
        value: "America/Los_Angeles",
        offset: -8
    },
    {
        label: "(UTC -07:00) Mountain Time (US & Canada)",
        value: "America/Denver",
        offset: -7
    },
    {
        label: "(UTC -06:00) Central Time (US & Canada)",
        value: "America/Chicago",
        offset: -6
    },
    {
        label: "(UTC -05:00) Eastern Time (US & Canada)",
        value: "America/New_York",
        offset: -5
    },
    {
        label: "(UTC -04:00) Atlantic Time (Canada)",
        value: "America/Halifax",
        offset: -4
    },
    {
        label: "(UTC -03:00) Buenos Aires, Montevideo",
        value: "America/Argentina/Buenos_Aires",
        offset: -3
    },
    {
        label: "(UTC -02:00) South Georgia & South Sandwich Islands",
        value: "Atlantic/South_Georgia",
        offset: -2
    },
    {
        label: "(UTC -01:00) Azores, Cape Verde",
        value: "Atlantic/Azores",
        offset: -1
    },
    {
        label: "(UTC 00:00) Greenwich Mean Time (GMT)",
        value: "Etc/UTC",
        offset: 0
    },
    {
        label: "(UTC +01:00) Central European Time (CET)",
        value: "Europe/Berlin",
        offset: 1
    },
    {
        label: "(UTC +02:00) Eastern European Time (EET)",
        value: "Europe/Athens",
        offset: 2
    },
    {
        label: "(UTC +03:00) Moscow Standard Time",
        value: "Europe/Moscow",
        offset: 3
    },
    {
        label: "(UTC +04:00) Gulf Standard Time",
        value: "Asia/Dubai",
        offset: 4
    },
    {
        label: "(UTC +05:00) Pakistan Standard Time",
        value: "Asia/Karachi",
        offset: 5
    },
    {
        label: "(UTC +05:30) India Standard Time",
        value: "Asia/Kolkata",
        offset: 5.5
    },
    {
        label: "(UTC +06:00) Bangladesh Standard Time",
        value: "Asia/Dhaka",
        offset: 6
    },
    {
        label: "(UTC +07:00) Indochina Time",
        value: "Asia/Bangkok",
        offset: 7
    },
    {
        label: "(UTC +08:00) China Standard Time",
        value: "Asia/Shanghai",
        offset: 8
    },
    {
        label: "(UTC +09:00) Japan Standard Time",
        value: "Asia/Tokyo",
        offset: 9
    },
    {
        label: "(UTC +10:00) Australian Eastern Standard Time",
        value: "Australia/Sydney",
        offset: 10
    },
    {
        label: "(UTC +11:00) Solomon Islands, Vanuatu",
        value: "Pacific/Guadalcanal",
        offset: 11
    },
    {
        label: "(UTC +12:00) Fiji, New Zealand Standard Time",
        value: "Pacific/Auckland",
        offset: 12
    }
];

export default timezones;
